import {fetcher} from "../../../api/fetcher.js";
import {insertValue} from "../../index.js";

export const createRange = (start, end) =>
  Array.from({length: end - start + 1}, (_, i) => start + i);

export const handlePagination = (totalPages, currentPage) => {
  const maxPageNumber = 5;

  if (totalPages <= maxPageNumber) {
    return Array.from({length: totalPages}, (_, idx) => idx + 1);
  }
  const numPages = 4;

  const leftSide = createRange(1, numPages);
  const rightSide = createRange(totalPages - numPages + 1, totalPages);
  const rangeToShow = [];

  if (leftSide.includes(currentPage)) {
    rangeToShow.push(...leftSide, "...", totalPages);
  } else if (rightSide.includes(currentPage)) {
    rangeToShow.push(1, "...", ...rightSide);
  } else {
    rangeToShow.push(1, "...", currentPage, currentPage + 1, "...", totalPages);
  }

  return rangeToShow;
};

export const createQueryString = (params, oldSearchParams) => {
  Object.entries(params).forEach(([key, value]) => {
    oldSearchParams.set(key, value);
  });
  const searchParams = oldSearchParams.toString();
  return searchParams ? `?${searchParams}` : "";
};

export const handleB16Response = async ({
  url,
  language,
  baseApiUrl,
  fullSlug = "",
  b16,
  adEnabled,
  isAdvancedSearchPage = false,
}) => {
  if (b16) {
    const params = b16?.params;
    const page = Number(url.searchParams.get("currentPage")) || 1;
    const sectionParams = url.searchParams.get("params");
    const taxonomy = url.searchParams.get("taxonomy");
    const filters = url.searchParams.get("filters");
    const paginationLink = {
      baseUrl: fullSlug,
      queryParams: {b16: true, taxonomy, filters, params: sectionParams || params},
    };
    if (isAdvancedSearchPage) {
      return paginationLink;
    }
    const {
      nb_total_page,
      current_page,
      posts,
      enable_card,
      card_position,
      filters_to_display,
      nb_total_posts,
    } = b16;

    if (page === 1 && !filters && !taxonomy) {
      let updatedPosts = posts ? [...posts] : [];

      if (enable_card && enable_card !== "0") {
        const hasPushmailCard = posts?.some((post) => post?.isPushmailCard);
        if (!hasPushmailCard) {
          updatedPosts = insertValue(posts, card_position - 1, {
            isPushmailCard: true,
          });
        }
      }

      // Insert Ad if conditions are met
      if (adEnabled && posts && posts.length < 12) {
        updatedPosts = insertValue(updatedPosts, 3, {
          isAd: true,
        });
      }
      return {
        paginationLink,
        queriedArticlesResponse: {
          totalPages: nb_total_page,
          currentPage: current_page,
          localFiltersData: updatedPosts,
          emptyResponse: updatedPosts?.length === 0,
          filters_to_display,
          params,
          nb_total_posts,
        },
      };
    }

    const queriedArticlesResponse = {};
    const filterResponse = await fetcher(
      baseApiUrl,
      `/wp-json/wp/v2/push_content/?${sectionParams}&page=${page}${taxonomy}${filters}&l=${language}`,
      {},
      false,
    );

    if (filterResponse.statusCode === 200) {
      queriedArticlesResponse.amountResult = filterResponse?.nb_total_posts;
      queriedArticlesResponse.localFiltersData = filterResponse?.posts;
      queriedArticlesResponse.totalPages = filterResponse?.nb_total_page;
      queriedArticlesResponse.currentPage = filterResponse?.current_page;
      queriedArticlesResponse.filters = `${taxonomy}${filters}`;
      queriedArticlesResponse.filterValue = filters;
      queriedArticlesResponse.emptyResponse = filterResponse?.posts?.length === 0;
    } else {
      queriedArticlesResponse.localFiltersData = filterResponse?.posts;
      queriedArticlesResponse.emptyResponse = filterResponse?.posts?.length === 0;
      queriedArticlesResponse.filters = `${taxonomy}${filters}`;
    }

    if (enable_card && enable_card !== "0" && filterResponse?.current_page === 1) {
      const hasPushmailCard = queriedArticlesResponse.localFiltersData?.some(
        (post) => post?.isPushmailCard,
      );
      if (!hasPushmailCard) {
        queriedArticlesResponse.localFiltersData = insertValue(
          queriedArticlesResponse.localFiltersData,
          card_position - 1,
          {
            isPushmailCard: true,
          },
        );
      }
    }
    if (adEnabled && posts && posts.length < 12) {
      queriedArticlesResponse.localFiltersData = insertValue(
        queriedArticlesResponse.localFiltersData,
        3,
        {
          isAd: true,
        },
      );
    }

    return {
      paginationLink,
      queriedArticlesResponse,
    };
  }

  return {
    paginationLink: {},
    queriedArticlesResponse: {},
  };
};

export const getB16Section = (data) =>
  data[0]?.acf?.sections_builder?.find(
    (s) => s.acf_fc_layout === "section--push-content",
  );
